import React from "react";

// Returns a React SVG component so that we may change the fill color and/or icon size of the SVG to whatever we want dynamically across hundreds of different websites and hundreds of different colors.
// This react component is the box SVG icon, typically used for the Order CTA.

const Repair = ({ fill, svgIconSize }) => {
    return (
        <svg
            version="1.1"
            id="fod-hybrid-swiper-side-panel-icon"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1920 1920"
            xmlSpace="preserve"
            style={{
                pointerEvents: "none",
                width: svgIconSize,
                height: svgIconSize,
            }}
        >
            <g fill={fill || "black"}>
                <path d="M513.9,1581.3c-18.3,0-36.4-4.9-52.3-14.1c-42.4-24.8-78.5-57.3-107.2-96.4c-29.7-40.5-26.3-96.3,8.1-132.6l295.1-311.4 l219.3,212.5l-287.4,309.1c-15.9,17.2-37.5,28.5-60.7,31.9C523.9,1581,518.9,1581.3,513.9,1581.3z M658.8,1085.1l-266.6,281.3 c-20.8,21.9-22.8,55.7-4.8,80.2c25.4,34.6,57.3,63.3,94.9,85.3c25,14.6,57.5,9.8,77.2-11.4l260-279.6L658.8,1085.1z"></path>
                <path d="M1339.5,642.5l-96.7-87.9l167-159.7l81.5,81.5L1339.5,642.5z M1302.9,553.8l33.9,30.8l97.7-107l-25.4-25.4L1302.9,553.8z"></path>
                <path d="M830.8,960.6l-151-151c-46.8,16.4-95.1,19.2-140.4,8.1c-45.5-11.2-87-36.6-116.8-71.6c-27.8-32.6-44.5-71.7-48.4-113.1 c-4.2-44.4,6.9-89.7,31.9-131l13.9-22.9l129.1,135.6l79.3-18.6l32.6-79.2L533.4,376.3l23.1-12.4c39.2-21.1,82-29.2,123.9-23.4 c39.5,5.5,76.4,22.8,106.6,50.3c33.1,30.1,55.6,69.7,64.9,114.5c9.2,44.2,5,91.8-12.2,138.6l150.5,144.9l-28.4,29.5L791.2,654.2 l5.4-13c41.8-99.3,8.1-178.9-37.3-220.1c-44.5-40.4-103.5-51.8-159-32l108.5,119.3l-50.5,122.7l-122.6,28.9l-107-112.4 c-25.3,59.1-16.5,123,25.2,171.9c53.1,62.3,140.8,80.9,223.4,47.3l12.6-5.1l169.9,169.9L830.8,960.6z"></path>
                <path d="M1305.4,1562.7c-10,0-19.9-0.7-29.7-2.2c-41.1-6.3-79.1-25.2-110.1-54.8c-33.2-31.8-56.3-74.6-64.9-120.7 c-8.5-45.5-3.1-93.2,15.6-138.7l-181.5-175.7l28.5-29.5l202.3,195.8l-6.3,13.3c-38.2,80.6-24.7,169.2,34.5,225.7 c46.5,44.4,109.8,56.8,170.2,34.9L1258,1397.7l35.8-120.8l125.4-43.4l112.9,115.1c22.9-54.3,14.9-113.8-22.9-160.5 c-38.6-47.7-116.1-85.9-217.7-49.8l-12.2,4.3l-202.2-202.8l29-28.9l184.1,184.7c48-14.8,96.2-16.4,140.1-4.5 c44.2,11.9,82.5,36.6,110.6,71.3c25.7,31.7,40.9,69.5,44.1,109.3c3.4,42.1-7.2,84.4-30.5,122.3l-13.7,22.3l-132.9-135.5l-80.9,28 l-23.1,78.1l128,136.6l-23.6,12.6C1375.2,1553.7,1340.1,1562.7,1305.4,1562.7z"></path>
                <rect
                    x="635.3"
                    y="837"
                    transform="matrix(0.6972 -0.7168 0.7168 0.6972 -309.322 1000.6544)"
                    width="789.4"
                    height="59"
                ></rect>
                <rect
                    x="645.4"
                    y="1108.1"
                    transform="matrix(0.6889 -0.7249 0.7249 0.6889 -692.3829 868.7404)"
                    width="41"
                    height="265.8"
                ></rect>
            </g>
        </svg>
    );
};

export default Repair;
